export default Object.freeze({
  phone: 'Phone',
  online: 'Online',
  in_person: 'In Person',
});
